
import { LibImg } from 'library';


function Canvas_RenderImage(props){




    //https://stackoverflow.com/questions/26688168/uncaught-securityerror-failed-to-execute-getimagedata-on-canvasrenderingcont


    var canvas = props.canvas;
    var ctx = props.ctx;


    //------------------------------------
    // sourceurl
    //------------------------------------

    var pathTo = window.location.origin + `${process.env.PUBLIC_URL}`;

    var sourceurl;

    //sourceurl = "data:image/gif;base64,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";

    //sourceurl = zoneObj['amazon_obj']['bucket_path'] + "admin/inventory/img/3890addfile_sys20190515199231id_.jpg";

    //sourceurl = "//colormyproject-com.s3.amazonaws.com/admin/inventory/img/3890addfile_sys20190515199231id_.jpg";

    sourceurl = pathTo + "/_resources/images/raceaway.jpg";




    //------------------------------------
    // add image
    //------------------------------------

    var img = new Image();
    img.onerror = function(){

        console.log('img.onerror');

    };
    img.onload = function(){ 
    
 
        // The image can be drawn from any source


        /*

        //ORIGINAL
        canvas.style.width = img.width + "px";
        canvas.style.height = img.height + "px";
        
        canvas.getContext("2d").drawImage(img, 0, 0, img.width,    img.height, 0, 0, canvas.width, canvas.height);
        */
 
        


        /*

        alert("Drawimage Data..."

            +"\ncanvas.width: "+canvas.width
            +"\ncanvas.height: "+canvas.height

            +"\ncanvas.width: "+canvas.offsetWidth
            +"\ncanvas.height: "+canvas.offsetWidth

        
            +"\nimg.width: "+img.width
            +"\nimg.height: "+img.height
            
        );

        */

        

        
        var img_w;
        var img_h;

        var img_x;
        var img_y;

        var mode;
        var imgmod;


        img_w = img.width;
        img_h = img.height;


        console.log("Initial Sizing..."


            +"\nCANVAS W: "+canvas.width
            +"\nCANVAS H: "+canvas.height

            +"\nCANVAS OFFSET W: "+canvas.offsetWidth
            +"\nCANVAS OFFSET H: "+canvas.offsetHeight

            +"\nIMG W: "+img_w
            +"\nIMG H: "+img_h

        );
        

        //==========================================================


        /*
        {
            imgW: NaN, 
            imgH: NaN, 
            adjust: {
                call: "readjust", 
                marginTop: NaN, 
                marginLeft: 0
            }
        }
        */




        mode = 'readjust';
    
        imgmod = LibImg.ModifyImageSize({

            call         :mode,
            divWidth     :canvas.width,
            divHeight    :canvas.height,
            width        :img.width,
            height       :img.height

        })

        //console.log(imgmod);
        //alert('check');



        img_w = imgmod['imgW'];
        img_h = imgmod['imgH'];
    
        img_x = imgmod.adjust['marginLeft'];
        img_y = imgmod.adjust['marginTop'];

        
        console.log("Img Mod Results..."

            +"\nMODE: "+mode

            +"\nIMG X: "+img_x
            +"\nIMG Y: "+img_y

            +"\nIMG W: "+img_w
            +"\nIMG H: "+img_h

            +"\nADJUST_OBJ: "+JSON.stringify(imgmod.adjust,null,2)
        );
        



        if(img_x < 20)
        {

            mode = 'fill_div';
        
            imgmod = LibImg.ModifyImageSize({

                call         :mode,
                divWidth     :canvas.width,
                divHeight    :canvas.height,
                width        :img.width,
                height       :img.height

            })

            img_w = imgmod['imgW'];
            img_h = imgmod['imgH'];

            img_x = imgmod.adjust['marginLeft'];
            img_y = imgmod.adjust['marginTop'];


            console.log("Reset Img Mod Results..."

                +"\nMODE: "+mode

                +"\nIMG X: "+img_x
                +"\nIMG Y: "+img_y

                +"\nIMG W: "+img_w
                +"\nIMG H: "+img_h

                +"\nADJUST_OBJ: "+JSON.stringify(imgmod.adjust,null,2)
            );
        

        
        }//if x
        //=====

        



        /*
        alert("Img Mod Results..."

            +"\nIMG X: "+img_x
            +"\nIMG Y: "+img_y

            +"\nIMG W: "+img_w
            +"\nIMG H: "+img_h

            +"\nADJUST_OBJ: "+JSON.stringify(imgmod.adjust,null,2)
        );

        */
        
        
        //==========================================================

        //https://www.w3schools.com/tags/canvas_drawimage.asp

        
        //canvas.getContext("2d").drawImage(img, 0, 0, img_w, img_h, 0, 0, canvas.offsetWidth, canvas.offsetHeight);
        //canvas.getContext("2d").drawImage(img, img_x, img_y, img_w, img_h);

        ctx.drawImage(img, img_x, img_y, img_w, img_h);
        //ctx.drawImage(img, 0, 0, 100, 57);


    };//img.onload

    img.setAttribute("crossOrigin","anonymous"); 
    img.setAttribute("src", sourceurl);
    //img.setAttribute("id","canvimg");









    

    /*

    if(init)
    {
        
        //------------------------------------
        // addEventListener ( mousemove )
        //------------------------------------

        canvas.removeEventListener('mousemove',function(e){},false);
        canvas.addEventListener("mousemove",function(e){


        
            var eventLocation = Canvas_GetEventLocation(this,e);
            var coord = "x=" + eventLocation.x + ", y=" + eventLocation.y;
            
            // Get the data of the pixel according to the location generate by the getEventLocation function
            var context = this.getContext('2d');
            var pixelData = context.getImageData(eventLocation.x, eventLocation.y, 1, 1).data; 
        
            // If transparency on the image
            if((pixelData[0] == 0) && (pixelData[1] == 0) && (pixelData[2] == 0) && (pixelData[3] == 0))
            {
                //coord += " (Transparent color detected, cannot be converted to HEX)";
                coord += "<br/>Invalid Color";
                
            }

            
            var rgb = pixelData[0]+","+pixelData[1]+","+pixelData[2];
            var hex = "#" + ("000000" + Canvas_RgbToHex(pixelData[0], pixelData[1], pixelData[2])).slice(-6);


            zoneObj['running_color'] = {

                'type':'Extracted',
                'rgb':rgb,
                'hex':hex
            };



            //console.log("HEX: "+hex);




            //------------------------------------
            // Draw the color and coordinates.
            //------------------------------------

            //------------
            //color
            //------------

            var canvcolor = document.getElementById("canvcolor");
            canvcolor.style.backgroundColor = hex;


            //------------
            //text
            //------------

            var lod = colorlib.LightOrDark(hex);
            switch(lod){
                case'light': var textcolor = 'black'; break;
                case'dark': var textcolor = 'white'; break;
            };

            var canvcolortxt = document.getElementById("canvcolortxt");
            canvcolortxt.style.color = textcolor;





            //------------
            //stats
            //------------
        
            if(zoneObj['view_canvstats'] 
            && zoneObj['view_canvstats'] != undefined
            )
            {
                
                var canvstatsbox = document.getElementById("canvstatsbox");
                //canvstatsbox.style.backgroundColor = hex;


                var canvstats = document.getElementById("canvstats");
                //canvstats.style.color = textcolor;
                

                    var html = '';



                    //---------------
                    //ORIGINAL
                    //---------------

                    //html += "RGB: "+rgb;
                    //html += "<br/>";
                    //html += "HEX: "+hex;
                    //html += "<br/>";
                    //html += coord;


                    //---------------
                    //inline
                    //---------------

                    html += "HEX: "+hex;
                    html += "&nbsp;/&nbsp;"; 

                    html += "RGB: "+rgb;
                    html += "&nbsp;/&nbsp;"; 

                    html += "COORD: "+coord;



                canvstats.innerHTML = html;


            }//==


        
        },false);



        //------------------------------------
        // addEventListener ( click )
        //------------------------------------

        canvas.removeEventListener("click",function(e){},false);
        canvas.addEventListener("click",function(e){
        
            var clicked_color = zoneObj['running_color'];
            //console.log(JSON.stringify(clicked_color,null,2));



            //----------------------------------------------

            var browser = detectlib.Browser();
            var mob = detectlib.Mobile();

            var is_mobile = mob['is_mobile'];

            //----------------------------------------------
            


            if(is_mobile) 
            {
                zoneObj['canv_clicked_color'] = clicked_color;
            }else{
                Process_CanvClick(clicked_color);
            }//==
            
            
        
        },false);


    }//==

    */

    


}







export {

    Canvas_RenderImage

}

